<div
  [style.height]="height()"
  class="flex items-center justify-center gap-[4px] overflow-hidden shrink-0 whitespace-nowrap"
  [ngClass]="getBadgeClasses()"
>
  <ng-content />
  @if (icon()) {
  <i
    (keyup)="onIconClicked($event)"
    (click)="onIconClicked($event)"
    class="fi fi-rr-{{ icon() }} w-[{{ iconSize() }}px] h-[{{ iconSize() }}px] leading-[{{ iconSize() }}px] text-[{{
      iconSize()
    }}px] block shrink-0 leading-[0]"
  ></i>
  }
</div>
